'use strict';

Object.defineProperty(exports, "__esModule", {
        value: true
});

var _throttle2 = require('lodash/throttle');

var _throttle3 = _interopRequireDefault(_throttle2);

var _values2 = require('lodash/values');

var _values3 = _interopRequireDefault(_values2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

tableDirective.$inject = ['$window', '$timeout'];
tableRowDirective.$inject = ['$window', '$timeout', '$compile'];


var _ = {
        throttle: _throttle3.default,
        values: _values3.default
};

var _module = angular.module('cb.strips.cbStripTabellenV1', []);

_module.directive('tableRow', tableRowDirective);
_module.directive('table', tableDirective);

exports.default = _module;

/**
 * tableDirective
 * This directive creates the fixed table header (table--fixed).
 * It checks if the table is in view with the utility function isTableInView
 */

function tableDirective($window, $timeout) {
        return {
                restrict: 'C',
                scope: {},
                link: tableDirectiveLink
        };

        function tableDirectiveLink(scope, element, attr) {
                var version = 1.00;
                // duplicate the table

                // do not proceed if this is a fixed table header
                if (element[0].classList.contains('table--fixed')) {
                        return;
                }
                // copy the table itself and add a fixed class
                var fixedTable = element[0].cloneNode(true);
                fixedTable.classList.add('table--fixed');

                // insert before the table
                element[0].parentElement.insertBefore(fixedTable, element[0]);

                // on scroll or resize trigger function with the table and the fixed copy
                var debouncedIsInView = _.throttle(function () {
                        return isTableInView(element[0], fixedTable);
                }, 100);
                $window.addEventListener('scroll', debouncedIsInView, false);
                $window.addEventListener('resize', debouncedIsInView, false);
        }
}

/**
 * Utility class to check if the table element is currently in view
 * and attach the correct class to the fixed table element
 * @param {*} origTable
 * @param {*} fixedTable
 */

function isTableInView(origTable, fixedTable) {
        // get the table height and retract footer height
        var tableHeight = origTable.offsetHeight - 60;

        // get the elements offset on the page
        var viewportOffset = origTable.getBoundingClientRect();
        var tableOffsetTop = viewportOffset.top;

        // get the width of the table
        var tableWidth = origTable.offsetWidth;

        // true if the original header is still visible
        var headerIsInView = Boolean(tableOffsetTop > 0);

        // determine if the view is on screen and it's not floating before
        var displayFixedHeader = headerIsInView ? false : Boolean(tableOffsetTop + tableHeight > 0);

        // set the header width to match the table width
        window.requestAnimationFrame(function () {
                fixedTable.style.width = tableWidth + 'px';
                fixedTable.style.display = displayFixedHeader ? 'table' : 'none';
        });
}

/**
 * The tableRowDirective creates the mobile optimised view.
 * This view is contained in the first table column and is only visible in mobile view.
 */
function tableRowDirective($window, $timeout, $compile) {
        return {
                restrict: 'C',
                scope: {},
                link: tableRowDirectiveLink
        };

        function tableRowDirectiveLink(scope, element, attr) {
                var version = 1.00;

                // by default set the item as not expanded;
                scope.isTableExpanded = false;

                scope.toggleExpand = function () {
                        scope.isTableExpanded = !scope.isTableExpanded;
                };

                // first check if the parent object has the class table-body
                var isInBody = element[0].parentElement.classList.contains('table-body');

                // and check if this table was already build
                // this check was added to fix table when used within Meer-Informatie strip
                var alreadyBuilt = element[0].querySelectorAll('.table-cell__title').length > 0;

                // if not do not trigger the directive
                if (!isInBody || alreadyBuilt) {
                        return;
                }

                // get the tableheader row.. ANd make an array of all it's elements
                var tableHeaderRowElem = element[0].parentNode.parentNode.querySelector('.table-header__row');

                var tableHeaderRowChildren = _.values(tableHeaderRowElem.children);
                var tableHeaderItems = [];

                tableHeaderRowChildren.forEach(function (element) {
                        tableHeaderItems.push(element.innerHTML);
                });

                // now get the values from the row
                var tableBodyRowChildren = _.values(element[0].children);
                var tableBodyItems = [];

                tableBodyRowChildren.forEach(function (element) {
                        tableBodyItems.push(element.innerHTML);
                });

                // get the first cell from the tablerow
                var firstRowCellElem = element[0].firstElementChild;
                var firstElemTitle = firstRowCellElem.innerHTML;

                // since we only need to get the values for the row cells after the first cell we delete the first entry
                tableHeaderItems.splice(0, 1);
                tableBodyItems.splice(0, 1);

                // create the new first TD element
                var firstRowContainerElem = document.createElement('td');
                firstRowContainerElem.classList.add('table-cell');
                firstRowContainerElem.setAttribute('ng-click', 'toggleExpand()');

                // create the title container which holds the visible value
                var firstRowTitleContainer = document.createElement('div');
                firstRowTitleContainer.classList.add('table-cell__title');
                firstRowTitleContainer.setAttribute('ng-class', '{\'table-cell__title--expanded\': isTableExpanded}');
                firstRowTitleContainer.innerHTML = firstElemTitle;

                // create the span arrow element
                var spanArrowElem = document.createElement('span');
                spanArrowElem.classList.add('table-cell__icon', 'icon');
                spanArrowElem.setAttribute('ng-class', '{\'icon--arrow-down\': !isTableExpanded, \'icon--arrow-up\': isTableExpanded}');
                firstRowTitleContainer.appendChild(spanArrowElem);

                var mobileRowContainerElem = document.createElement('div');
                mobileRowContainerElem.classList.add('mobile-container');
                mobileRowContainerElem.setAttribute('ng-show', 'isTableExpanded');

                // create the list items
                tableHeaderItems.forEach(function (headerItem, index) {
                        // container element
                        var mobileRowElem = document.createElement('div');
                        mobileRowElem.classList.add('mobile-row__item');

                        var mobileRowTitle = document.createElement('div');
                        mobileRowTitle.classList.add('mobile-row__title');

                        var mobileRowValue = document.createElement('div');
                        mobileRowValue.classList.add('mobile-row__value');
                        // setting the values
                        mobileRowTitle.innerHTML = headerItem;
                        mobileRowValue.innerHTML = tableBodyItems[index];

                        mobileRowElem.appendChild(mobileRowTitle);
                        mobileRowElem.appendChild(mobileRowValue);

                        mobileRowContainerElem.appendChild(mobileRowElem);
                });

                firstRowContainerElem.appendChild(firstRowTitleContainer);
                firstRowContainerElem.appendChild(mobileRowContainerElem);

                // remove the original td element
                firstRowCellElem.parentNode.removeChild(firstRowCellElem);

                // compile the replacement element
                var compiledEl = $compile(firstRowContainerElem)(scope);
                element[0].insertBefore(compiledEl[0], element[0].querySelector('.table-cell'));

                //trigger GA version event
        }
}


//////////////////
// WEBPACK FOOTER
// ./src/strips/tabellen-v1/tabellen.directive.js
// module id = 960
// module chunks = 1